import { appConfig } from '../init/getAppConfig';
import { EnvType } from '../app/types/enum';

export function getBoldChatEnv(): string {
  if (
    appConfig.envType == EnvType.dev ||
    appConfig.envType == EnvType.qa ||
    appConfig.envType == EnvType.staging
  ) {
    return 'qa';
  }
  return 'prod';
}
